// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import tts from '@console/api/tts'

import createRequestLogic from '@ttn-lw/lib/store/logics/create-request-logic'

import * as as from '@console/store/actions/application-server'

const getAsConfigurationLogic = createRequestLogic({
  type: as.GET_AS_CONFIGURATION,
  process: async () => tts.As.getConfiguration(),
})

const collectStreamMessages = async stream =>
  await new Promise((resolve, reject) => {
    const collected = []
    stream.on('message', message => collected.push(message))
    stream.on('error', reject)
    stream.on('close', () => resolve(collected))
    stream.open()
  })

const getStoredApplicationUplinkMessagesLogic = createRequestLogic({
  type: as.GET_STORED_APPLICATION_UPLINK_MESSAGES,
  process: async ({ action }) => {
    const { appId, limit, last } = action.payload
    const stream = await tts.As.getStoredApplicationUplinkMessages(appId, limit, last)
    return await collectStreamMessages(stream)
  },
})

const getStoredApplicationUplinkMessagesCountLogic = createRequestLogic({
  type: as.GET_STORED_APPLICATION_UPLINK_MESSAGES_COUNT,
  process: async ({ action }) => {
    const { appId, last } = action.payload
    const data = await tts.As.getStoredApplicationUplinkMessagesCount(appId, last)
    return Object.values(data.count ?? {}).reduce((sum, value) => sum + value, 0)
  },
})

const getStoredDeviceUplinkMessagesLogic = createRequestLogic({
  type: as.GET_STORED_DEVICE_UPLINK_MESSAGES,
  process: async ({ action }) => {
    const { appId, deviceId, limit, last } = action.payload
    const stream = await tts.As.getStoredDeviceUplinkMessages(appId, deviceId, limit, last)
    return await collectStreamMessages(stream)
  },
})

export default [
  getAsConfigurationLogic,
  getStoredApplicationUplinkMessagesLogic,
  getStoredApplicationUplinkMessagesCountLogic,
  getStoredDeviceUplinkMessagesLogic,
]
